module.exports = __webpack_public_path__ + "img/Profil_CS-Slimlineri_Large.d6ef97b3.jpg";